<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>结算管理</el-breadcrumb-item>
            <el-breadcrumb-item>结算查询</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" label-position="right" :model="formFilter" class="demo-form-inline">
                <el-form-item label="结算时间">
                    <el-date-picker
                        v-model="formFilter.daterange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="服务编号">
                    <el-input v-model="formFilter.no" placeholder="请输入服务编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onFilter" type="primary">查询</el-button>
                    <el-button v-if="records.length > 0" @click="onExport" type="default">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    ref="recordTable"
                    border
                    stripe
                    :data="records"
                    @selection-change="selectionChange"
                >
                    <el-table-column
                        type="selection"
                        align="center"
                        width="55"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="confirm_settlement_time"
                        align="center"
                        label="结算时间">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        show-overflow-tooltip
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        prop="sub_no"
                        align="center"
                        label="服务编号">
                    </el-table-column>
                    <el-table-column
                        prop="member_name"
                        align="center"
                        width="130"
                        label="服务人员">
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        width="130"
                        label="结算金额">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="130"
                        label="银行回单">
                        <template slot-scope="scope">
                            {{ scope.row.is_receipt === 1 ? '已生成' : '未生成' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="160"
                        label="结算状态">
                        <template slot-scope="scope">
                            {{payStatus[scope.row.status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="65">
                        <template slot-scope="scope">
                            <el-button type="text" size="medium" @click="goPage(`/index/pay/detail?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-extra">
                    <div class="operation">
                        <el-checkbox
                            v-model="isCheckAll"
                            :indeterminate="isIndeterminate"
                            @change="serviceTableSelectChange"
                        ></el-checkbox>
                        <el-button
                            type="default"
                            :disabled="batchStatus"
                            @click="batchDownloadReceipt"
                            size="medium"
                            style="margin-right: 10px;"
                        >
                            批量下载回单
                        </el-button>
                    </div>
                    <div class="pagination" v-if="total_page > 1">
                        <el-pagination
                            background
                            layout="prev, pager, next, sizes"
                            :page-size="pageSize"
                            :current-page="currentPage"
                            @current-change="onPageChange"
                            @size-change="onSizeChange"
                            :page-count="total_page">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'Index',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            formFilter: {
                daterange: [],
                start_time: '',
                end_time: '',
                no: ''
            },
            form: {
                daterange: [],
                start_time: '',
                end_time: '',
                no: ''
            },
            records: [],
            total_page: 1,
            pageSize: 10,
            payStatus: ['', '', '', '', '', '', '', '', '', '', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成'],
            isCheckAll: false,
            isIndeterminate: false,
            batchStatus: true
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getRecords()
    },
    methods: {
        onSizeChange (e) {
            this.currentPage = 1
            this.pageSize = e
            this.getRecords()
        },
        serviceTableSelectChange (e) {
            this.$refs.recordTable.toggleAllSelection(e)
        },
        selectionChange (selection) {
            this.isIndeterminate = selection.length > 0 && selection.length < this.records.length
            this.isCheckAll = selection.length === this.records.length
            const isReceipt = selection.some(item => item.is_receipt === 0)
            this.batchStatus = isReceipt
        },
        batchDownloadReceipt () {
            const selection = this.$refs.recordTable.selection
            const ids = selection.map(item => item.sub_id)
            this.download(`${process.env.VUE_APP_BASE}/api/user/downloadreceipt?sub_ids=${JSON.stringify(ids)}`)
        },
        onExport () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downloadsettlement?no=${this.form.no}&start_time=${this.form.start_time}&end_time=${this.form.end_time}`, '结算列表.xls')
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        getRecords (page = this.currentPage) {
            this.$http.get('/api/user/account/settlement', {
                params: {
                    page,
                    size: this.pageSize,
                    start_time: this.formFilter.start_time,
                    end_time: this.formFilter.end_time,
                    no: this.formFilter.no
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.records = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onFilter () {
            this.formFilter.start_time = this.getDateFromRange(this.formFilter.daterange)[0]
            this.formFilter.end_time = this.getDateFromRange(this.formFilter.daterange)[1]
            this.$store.commit('changeCondition', this.formFilter)
            this.getRecords(1)
            this.form = this.formFilter
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getRecords(e)
        },
        getDateFromRange (d) {
            let daterange = !d ? [] : d
            let date0 = !(daterange[0] === '' || !daterange[0]) ? `${daterange[0].getFullYear()}-${daterange[0].getMonth() + 1}-${daterange[0].getDate()}` : ''
            let date1 = !(daterange[1] === '' || !daterange[1]) ? `${daterange[1].getFullYear()}-${daterange[1].getMonth() + 1}-${daterange[1].getDate()}` : ''
            return [date0, date1]
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    .data-overview {
        height: 78px;
    }
</style>
